(function() {

  var linkFunction = function($scope, element, attrs) {
    // console.log("Payment Summary Link Func: ", $scope, element, attrs);
    $scope.editable = attrs.editable === 'false' ? false : true;
  };

  var controllerFunction = function($scope, $rootScope, $state, UserSession, loggerService, loggerServiceHelper) {
    // console.log("Payment Summary Controller Func: ", $scope);
    
    var log = loggerService(loggerServiceHelper.setCategory(CVSLOGHELPER.CATEGORY.PAYMENT_REGISTERED) + loggerServiceHelper.setFlow(CVSLOGHELPER.FLOW.BALANCE));
    log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.START));
    $scope.wcmContent = wcmContent;
    $scope.dashboardPageAutoPay={};
    $scope.dashboardPageAutoPay.schedule=angular.copy(UserSession.accountData.activeMop &&UserSession.accountData.activeMop.payment.frequency && (UserSession.accountData.activeMop && ""+UserSession.accountData.activeMop.payment.frequency).toUpperCase()=="IMMEDIATE"?0:UserSession.accountData.activeMop.payment.frequency);
    $scope.dashboardPageAutoPay.limit=angular.copy(UserSession.accountData.activeMop && UserSession.accountData.activeMop.payment.amount);
    $scope.dashboardPageAutoPay.method=angular.copy(UserSession.accountData.activeMop && UserSession.accountData.activeMop.payment.method);
    $scope.dashboardPageAutoPay.accountNumber=angular.copy(UserSession.accountData.activeMop &&UserSession.accountData.activeMop.accountNumber);
    $scope.dashboardPageAutoPay.paymentMethodId=angular.copy(UserSession.accountData.activeMop && UserSession.accountData.activeMop.paymentMethodId);
    $scope.dashboardPageAutoPay.mopType=angular.copy(UserSession.accountData.activeMop && UserSession.accountData.activeMop.payment.mopType);
        /*UserSession.paymentMethod=UserSession.accountData.activeMop.paymentMethodId;
    //UserSession.paymentMopType = UserSession.accountData.getMopById(UserSession.paymentMethod).payment.method;
    UserSession.autoPay.schedule=UserSession.accountData.activeMop.payment.frequency && UserSession.accountData.activeMop.payment.frequency=="IMMEDIATE"?0:UserSession.accountData.activeMop.payment.frequency;
    UserSession.reviewPageAutoPay.limit=UserSession.accountData.activeMop.payment.amount;*/
    $scope.continue=function(){
      createChannelUrl('recurringPayment');
    };
    $scope.editMop = function(mop) {
      //localStorage.clear();
      var componentName=cvsUtility.componentName();
      if(componentName && (componentName=="RFR" || componentName=="myAccount" )){
        window.top.location=createChannelUrl('editAutoPayAD');
      }else{
        UserSession.paymentType="auto";
        var dest = mop.payment.method == "CHECK" ? "edit-bank-account-info" : "edit-payment-card-info";
        $state.go(dest, { 'mopid': mop.paymentMethodId});
      }

    };

    $scope.editAutoPayment=function(){
      var componentName=cvsUtility.componentName();
      if(componentName && (componentName=="RFR" || componentName=="myAccount" )){
        window.top.location=createChannelUrl('editAutoPayAF');
      }else{
        $state.go("automatic-payments");
      }
    }

    $rootScope.fromAccountsAutopaySummary = false;
    $scope.editMopRecurring = function () {
      $rootScope.fromAccountsAutopaySummary = true;
      log.debug(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.BUTTON_CLICK) + loggerServiceHelper.setStep("EditAutomaticPayment") + loggerServiceHelper.setDescription("Navigating to payment method page"));
      log.info(loggerServiceHelper.setAction(CVSLOGHELPER.ACTION.PAGE_LOAD) + loggerServiceHelper.setStep(CVSLOGHELPER.STEP.END));
      $state.go("payment-methods", {
        'paymenttype': 'auto'
      });
    }


  };

  var directiveFunction = function() {
    return {
      restrict: 'E',
      templateUrl: '../payments/app/components/autopaySummaryDashboard/autopaySummaryDashboard.template.html',
      controller: controllerFunction,
      link: linkFunction
    }
  }

  controllerFunction.$inject = ["$scope", "$rootScope", "$state", "userSession",'loggerService', 'loggerServiceHelper'];
  angular.module('cvsApp').directive('autopaySummaryDashboard', directiveFunction);


})();
